import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { useAuth } from "../../../context/AuthContext";

const RequireAuth = () => {
  const { authChecked, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!authChecked) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <Loader2 className="animate-spin text-blue-900" size={32} />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/login" state={{ from: location }} replace />
    );
  }

  return <Outlet />;
};

export default RequireAuth;
